'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // 에러 로깅
    console.error('Error:', error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <h1 className="text-6xl font-bold text-red-600 mb-4">오류</h1>
      <h2 className="text-2xl font-semibold text-gray-600 mb-4">
        문제가 발생했습니다
      </h2>
      <p className="text-gray-500 mb-8 text-center max-w-md">
        {error.message || '예상치 못한 오류가 발생했습니다. 다시 시도해주세요.'}
      </p>
      <div className="flex gap-4">
        <button
          onClick={reset}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          다시 시도
        </button>
        <button
          onClick={() => (window.location.href = '/')}
          className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
        >
          홈으로 돌아가기
        </button>
      </div>
    </div>
  );
}
